import styled from 'styled-components';
import { colors } from '../../../../defaultTheme';
export const SkeletonRow = styled.div `
  background-color: ${colors.lighterGrey};
  background-image: linear-gradient(
    90deg,
    ${colors.lighterGrey},
    ${colors.lightGrey},
    ${colors.lighterGrey}
  );
  background-size: 400px 100%;
  background-repeat: no-repeat;
  border-radius: 4px;
  display: block;
  margin: 16px 0;
  line-height: 1;
  width: ${({ width }) => width};
  align-self: ${({ align }) => align || 'auto'};
  animation: loader 1200ms ease-in-out infinite;

  @keyframes loader {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: calc(400px + 100%) 0;
    }
  }
`;
export const HorizontalCardWrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
export const SkeletonRowWrapper = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
export const SpacingForSkeletonRow = styled.div `
  padding: ${(props) => props.padding};
`;
